import React from "react";
import {
  DashboardOutlined,
  UserOutlined,
  QrcodeOutlined,
  ForkOutlined,
  TrophyOutlined,
  TeamOutlined,
} from "@ant-design/icons";

export const subAdmin = [
  {
    title: "Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/wave-cards",
  },
  {
    title: "Leads Inbox",
    icon: <ForkOutlined />,
    link: "/app/lead-generation",
  },
];
export const whiteLabelAdmin = [
  {
    title: "Cards",
    icon: <QrcodeOutlined />,
    link: "/app/my-cards",
  },
  // {
  //   title: "Leads Inbox",
  //   icon: <ForkOutlined />,
  //   link: "/app/lead-generation",
  // },
];
export const actingadmin = [
  {
    title: "Dashboard",
    icon: <DashboardOutlined />,
    link: "/app",
  },
  {
    title: "Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/wave-cards",
  },
  {
    title: "Leads Inbox",
    icon: <ForkOutlined />,
    link: "/app/lead-generation",
  },
  {
    title: "Subscriptions and Plans",
    icon: <TrophyOutlined />,
    link: "/app/subscriptions-and-plans",
  },
];
export const editoradmin = [
  {
    title: "Dashboard",
    icon: <DashboardOutlined />,
    link: "/app",
  },

  {
    title: "Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/wave-cards",
  },
  {
    title: "Leads Inbox",
    icon: <ForkOutlined />,
    link: "/app/lead-generation",
  },
];
export const vieweradmin = [
  {
    title: "Dashboard",
    icon: <DashboardOutlined />,
    link: "/app",
  },
  {
    title: "Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/wave-cards",
  },
  {
    title: "Leads Inbox",
    icon: <ForkOutlined />,
    link: "/app/lead-generation",
  },
];
export const admin = [
  {
    title: "Dashboard",
    icon: <DashboardOutlined />,

    link: "/app",
  },

  {
    title: "Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/wave-cards",
  },
  {
    title: "Leads Inbox",
    icon: <ForkOutlined />,
    link: "/app/lead-generation",
  },
  {
    title: "Subscriptions and Plans",
    icon: <TrophyOutlined />,
    link: "/app/subscriptions-and-plans",
  },
  {
    title: "Team Collaboration",
    icon: <TeamOutlined />,
    link: "/app/team-collaboration",
  },
];
export const superAdmin = [
  {
    title: "Dashboard",
    icon: <DashboardOutlined />,
    link: "/app",
  },
  {
    title: "All Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/all-wave-cards",
  },
  {
    title: "Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/wave-cards",
  },

  {
    title: "Admins",
    icon: <UserOutlined />,
    link: "/app/admins",
  },
  {
    title: "Sub Users",
    icon: <UserOutlined />,
    link: "/app/subusers",
  },
  {
    title: "Leads Inbox",
    icon: <ForkOutlined />,
    link: "/app/lead-generation",
  },
  {
    title: "Team Collaboration",
    icon: <TeamOutlined />,
    link: "/app/team-collaboration",
  },
];
export const superAdminEditor = [
  {
    title: "Dashboard",
    icon: <DashboardOutlined />,
    link: "/app",
  },
  {
    title: "All Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/all-wave-cards",
  },
  {
    title: "Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/wave-cards",
  },

  {
    title: "Admins",
    icon: <UserOutlined />,
    link: "/app/admins",
  },
  {
    title: "Sub Users",
    icon: <UserOutlined />,
    link: "/app/subusers",
  },
  {
    title: "Leads Inbox",
    icon: <ForkOutlined />,
    link: "/app/lead-generation",
  },
];
export const developer = [
  // {
  //   title: "Dashboard",
  //   icon: <DashboardOutlined />,
  //   link: "/app",
  // },
  {
    title: "All Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/all-wave-cards",
  },
  {
    title: "Wave Cards",
    icon: <QrcodeOutlined />,
    link: "/app/wave-cards",
  },

  {
    title: "Admins",
    icon: <UserOutlined />,
    link: "/app/admins",
  },
  {
    title: "Sub Users",
    icon: <UserOutlined />,
    link: "/app/subusers",
  },
  {
    title: "Leads Inbox",
    icon: <ForkOutlined />,
    link: "/app/lead-generation",
  },
];
